export const PROTECT_YOU = [
  {
    id: 1,
    title: 'Неуплата и раннее выселение',
    description:
      'Если жилец перестал платить или съехал без предупреждения — компенсируем месячную аренду и до 2 недель простоя квартиры.',
  },
  {
    id: 2,
    title: 'Гражданская ответственность перед 3-ми лицами',
    description: 'Если что-то случится в вашей квартире и пострадает имущество соседей — выплатим до 300 000 р.',
  },
  {
    id: 3,
    title: 'Ущерб от пожара, потопа или электричества',
    description: 'Если от любых неприятностей пострадает ваше имущество — выплатим до 575 000 р.',
  },
  {
    id: 4,
    title: 'Ущерб, нанесённый жильцом',
    description: 'Если ваше имущество пострадает из-за человеческого фактора — выплатим до 200 000 р.',
  },
];
